import { Component, Input, OnInit } from '@angular/core';
import { MyProfileModel } from 'src/shared/model/UserProfile';

import { AuthService } from 'src/shared/service/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';
import { JqueryDialogService } from '../../ui-components/jquery-dialog/jquery-dialog.service';
import { SecurityQuestionAnswer } from '../../security/QueryStringParam';
import { RestService } from '../../../shared/service/rest.service';
import { DynamicModalService } from '../../ui-components/dynamic-modals/dynamic-modal.service';
import { AbstractDataProvider } from '../../AbstractDataProvider';

@Component({
  selector: 'app-edit-security-questions',
  templateUrl: './edit-security-questions.component.html',
  styleUrls: ['./edit-security-questions.component.scss']
})
export class EditSecurityQuestionsComponent implements OnInit {
  userProfileEntity: MyProfileModel = new MyProfileModel();
  display: boolean;
  alertMessage: string;

  questionList = [{SecQuestionText: 'dd', SecQuestionCode: 'CD1'}];
  @Input() securityQuestionAnswer: SecurityQuestionAnswer = new SecurityQuestionAnswer();

  constructor(
    public rest: RestService,
    private authService: AuthService,
    private dynamicModalService: DynamicModalService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private jqueryDialogService: JqueryDialogService,
    private abstractDataProvider: AbstractDataProvider) {
  }


  ngOnInit() {
    this.getListOfSecurityQuestions();
  }


  getListOfSecurityQuestions() {
    const url = 'api/Configuration/GetSecurityQuestionList';
    this.abstractDataProvider.getData(url).subscribe(
      (posts) => {
        this.questionList = posts.SecurityQuestions;
      },
      (error) => {
        this.display = true;
        this.alertMessage = error.error && error.error.Message;
      }
    );
  }


  onConfirm() {
    this.display = false;
  }

}
